import React from "react";
import { useLanguage } from "src/utils/localization/languages/I18nContext";
import { useRemoteOffers } from "src/utils/useRemoteOffers";
import { WindowLocation } from "@reach/router";
import { OffersMosaic } from "components/OffersMosaic/OffersMosaic";
import { MosaicLayoutProps } from "@silversea-ssc/ui-components-react";

export interface OffersCollectionMosaicProps extends MosaicLayoutProps {
  location: WindowLocation;
}

const OffersCollectionMosaic: React.FC<OffersCollectionMosaicProps> = (
  props
) => {
  const { location } = props;
  const language = useLanguage();
  const { data } = useRemoteOffers(language, location);
  if (!data) return null;

  return <OffersMosaic {...props} data={data}></OffersMosaic>;
};

export default OffersCollectionMosaic;
